import React, { Fragment} from 'react'
import RestaurantList from '../../Component/RestaurantList/RestaurantList'
import MenuBottom from '../../Component/menuBottom/MenuBottom'
import Style from './RestaurantsList.module.css'
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'

const RestaurantsList = () => {
    return (
        <Fragment>
            <div className={Style.PageHolder}>
                <div className={Style.FixPage}>
                    <BurgerMenuTitle title={"همه رستوران ها"}/>
                    <div className={Style.ListHolder}>
                        <RestaurantList/>
                    </div>
                </div>
            </div>
            <MenuBottom/>
        </Fragment>
    )
}
 
export default RestaurantsList
